module.exports = __webpack_public_path__ + "media/images/icon-card/icon-card-03-c24fa9f774103475b5cb7fe6c66c258e.svg";